<template>
  <a-row :gutter="10" style="margin-top: 10px">
    <a-form :layout="formLayout" labelAlign="left" :form="searchForm" @submit="handleSubmit">
      <a-col :span="6">
<!--        <a-form-item label="职位" :label-col="labelCol" :wrapper-col="wrapperCol">-->
<!--          <a-select-->
<!--              allowClear-->
<!--              v-decorator="['personnel_type']"-->
<!--              :options="[{ label: '司机', value: 0 },{ label: '押运员', value: 1 }]"-->
<!--              placeholder="请选择职位"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入手机号码"
              v-decorator="['mobile']"
          />
        </a-form-item>
<!--        <a-form-item label="人员状态" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-select-->
<!--              allowClear-->
<!--              v-decorator="['status']"-->
<!--              :options="[{ label: '在职', value: 0 },{ label: '离职', value: 1 },{ label: '请假中', value: 2 }]"-->
<!--              placeholder="请选择人员状态"-->
<!--          />-->
<!--        </a-form-item>-->
      </a-col>
      <a-col :span="6">
        <a-form-item label="身份证姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入身份证姓名"
              v-decorator="['personnel_name']"
          />
        </a-form-item>


      </a-col>
      <a-col :span="6">
        <a-form-item label="身份证号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
              placeholder="请输入身份证号码"
              v-decorator="['idcard_number']"
          />
        </a-form-item>
<!--        <a-form-item label="注册时间" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-range-picker-->
<!--              format="YYYY-MM-DD"-->
<!--              v-decorator="['create_time']"-->
<!--          />-->
<!--        </a-form-item>-->

      </a-col>
      <a-col :span="6">
        <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-button style="margin-right: 10px" type="primary" html-type="submit" icon="search">搜索</a-button>
          <a-button @click="handleReset">重置表单</a-button>
        </a-form-item>
      </a-col>
      <a-col :span="24" style="text-align: right">

      </a-col>
    </a-form>
  </a-row>
</template>
<script>
import {SelectRegion} from '@/components'

export default {
  name: 'searchForm',
  components: {
    SelectRegion
  },
  data() {
    return {
      searchForm: this.$form.createForm(this),
      queryParam: {},
      formLayout: 'horizontal',
      labelCol: {
        style: 'width: 70px;float:left;margin-right:10px;white-space: nowrap;\n' +
            'text-overflow: ellipsis;\n' +
            '-o-text-overflow: ellipsis;\n' +
            'overflow: hidden;'
      },
      wrapperCol: {style: 'width: calc( 95% - 70px );float:left'},
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      const {searchForm: {validateFields}} = this
      validateFields((errors, values) => {
        if (errors) {
          return false
        }
        this.$emit('handleSubmit', values)
      })
    },
    handleReset() {
      this.searchForm.resetFields()
    }
  }
}
</script>
<style scoped lang="less">

</style>
